var _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgCall(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 34,
    height: 34.001,
    viewBox: "0 0 34 34.001",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "call",
    transform: "translate(0)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_973",
    "data-name": "Group 973",
    transform: "translate(0 0)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_972",
    "data-name": "Group 972",
    transform: "translate(0 0)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_3071",
    "data-name": "Path 3071",
    d: "M33.34,27.036l-3.769-2.513L26.22,22.289a1.484,1.484,0,0,0-1.993.324l-2.073,2.665a1.477,1.477,0,0,1-1.885.391,24.141,24.141,0,0,1-6.741-5.195,24.314,24.314,0,0,1-5.195-6.741,1.477,1.477,0,0,1,.391-1.885l2.665-2.073a1.484,1.484,0,0,0,.324-1.993L9.547,4.534,6.965.661a1.484,1.484,0,0,0-2-.45L1.989,2A3.638,3.638,0,0,0,.337,4.136C-.477,7.1-.641,13.653,9.854,24.148S26.9,34.478,29.865,33.664A3.637,3.637,0,0,0,32,32.012l1.786-2.977A1.484,1.484,0,0,0,33.34,27.036Z",
    transform: "translate(0 0)",
    fill: "#7dbaab"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_3072",
    "data-name": "Path 3072",
    d: "M283.068,62.964a9.977,9.977,0,0,1,9.966,9.966.586.586,0,1,0,1.172,0,11.15,11.15,0,0,0-11.138-11.138.586.586,0,1,0,0,1.172Z",
    transform: "translate(-263.723 -57.689)",
    fill: "#7dbaab"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_3073",
    "data-name": "Path 3073",
    d: "M283.067,115.928a6.456,6.456,0,0,1,6.448,6.448.586.586,0,0,0,1.172,0,7.63,7.63,0,0,0-7.621-7.621.586.586,0,1,0,0,1.172Z",
    transform: "translate(-263.722 -107.135)",
    fill: "#7dbaab"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_3074",
    "data-name": "Path 3074",
    d: "M283.068,168.9A2.934,2.934,0,0,1,286,171.826a.586.586,0,1,0,1.172,0,4.108,4.108,0,0,0-4.1-4.1.586.586,0,1,0,0,1.172Z",
    transform: "translate(-263.723 -156.585)",
    fill: "#7dbaab"
  }))))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgCall);
export default __webpack_public_path__ + "static/media/call.9de36217a28b3771da7c1c2410b8d613.svg";
export { ForwardRef as ReactComponent };